import React, { useState } from 'react';
import { Modal, Form, Select, Checkbox, Switch, message } from 'antd';
import api from '../utils/api';

const ManageTeamMemberModal = ({ member, hostels, onClose, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const employeeType = Form.useWatch('employeeType', form);

  const initialHostelIds = member.accessibleHostels?.map((h) => (typeof h === 'object' ? h._id : h).toString()) || [];
  const initialHostel = member.hostel ? (typeof member.hostel === 'object' ? member.hostel._id : member.hostel) : '';

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      const submitData = {
        isActive: values.isActive,
        employeeType: values.employeeType,
      };
      if (values.employeeType === 'accountant') {
        if (!values.hostelIds?.length) {
          message.error('Accountants must have at least one accessible hostel');
          return;
        }
        submitData.hostelIds = values.hostelIds;
      } else {
        if (!values.hostel) {
          message.error('Please select a hostel');
          return;
        }
        submitData.hostel = values.hostel;
      }
      setLoading(true);
      await api.patch(`/admin/team-members/${member._id}/access`, submitData);
      message.success('Employee updated');
      onSuccess();
      onClose();
    } catch (err) {
      if (err.errorFields) return;
      message.error(err.response?.data?.message || 'Error updating employee');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={`Manage: ${member?.name}`}
      open={!!member}
      onCancel={onClose}
      onOk={handleSubmit}
      confirmLoading={loading}
      destroyOnClose
      okText="Update"
      width={480}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          isActive: member?.isActive !== undefined ? member.isActive : true,
          employeeType: member?.employeeType || '',
          hostelIds: initialHostelIds,
          hostel: initialHostel || undefined,
        }}
      >
        <Form.Item name="isActive" label="Active Account" valuePropName="checked" extra="Inactive members cannot log in">
          <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
        </Form.Item>
        <Form.Item name="employeeType" label="Employee Type" rules={[{ required: true }]}>
          <Select
            options={[
              { value: 'cleaner', label: 'Cleaner' },
              { value: 'cook', label: 'Cook' },
              { value: 'accountant', label: 'Accountant' },
              { value: 'guard', label: 'Guard' },
              { value: 'driver', label: 'Driver' },
            ]}
          />
        </Form.Item>
        {employeeType === 'accountant' && (
          <Form.Item name="hostelIds" label="Accessible Hostels" rules={[{ required: true, message: 'Select at least one hostel' }]}>
            <Checkbox.Group style={{ width: '100%', maxHeight: 200, overflow: 'auto', display: 'block' }}>
              {hostels.map((h) => (
                <div key={h._id}><Checkbox value={h._id}>{h.name}</Checkbox></div>
              ))}
            </Checkbox.Group>
          </Form.Item>
        )}
        {employeeType && employeeType !== 'accountant' && (
          <Form.Item name="hostel" label="Hostel" rules={[{ required: true }]}>
            <Select placeholder="Select hostel" options={hostels.map((h) => ({ value: h._id, label: h.name }))} />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default ManageTeamMemberModal;
